module.exports = __webpack_public_path__ + "img/pick2.a67385b0.png";